import VerifiedIcon from '@mui/icons-material/Verified';
import { Alert, Button, Grid, Link, Paper, Typography } from '@mui/material';
import { Box, Container, Stack } from '@mui/system';
import { useState } from 'react';

import BusinessTaxSubMenu from '@/components/nav/BusinessTaxSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
// import type { LayoutWrapperContents } from '@/types/LayoutWrapperContents';

const BusinessStateDelaware = () => {
  const [open, setOpen] = useState(false);

  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Extend your business tax return deadline with Form 7004.`,
  //   SubHeading:
  //     'E-file now and get more time to ensure accuracy. File now for peace of mind.',
  //   CtaText: 'E-file Form 7004 Now',
  //   CtaSubHeading: `Takes 3 steps and less than 5 minutes`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=sticky`,
  //   isActive: true,
  // };

  return (
    <AppLayout
      //  LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="Delaware Business Tax Filing Requirements | TaxZerone"
          description="Learn Delaware business tax forms, filing deadlines, extensions, rates, and penalties. Stay fully compliant with the Division of Revenue using TaxZerone"
          keywords=" "
          canonical="business-tax/state-filing/delaware-tax-filing-requirements/"
          jsonLdPricing=""
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="1658"
          ogShareImg=""
        />
      }
    >
      <BusinessTaxSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />

      {/* <Container maxWidth="md">
        <Box sx={{ px: 2, mt: 3, mx: 0 }}>
          <Alert
            severity="warning"
            icon={<WarningIcon sx={{ fontSize: 30 }} />}
            sx={{ borderRadius: 3 }}
          >
            <AlertTitle
              sx={{ fontSize: { xs: 18, sm: 20, md: 22 }, fontWeight: 600 }}
            >
              Attention! Final Day to E-File Form W-2!
            </AlertTitle>

            <Typography
              variant="body1"
              sx={{ fontSize: { xs: 16, sm: 17, md: 18 } }}
            >
              Don&apos;t miss the deadline! Today is the <b>Last Day</b> to
              Submit Your <b>Form W-2</b> Electronically!
            </Typography>
          </Alert>
        </Box>
      </Container> */}
      <Container maxWidth="xl" component="section">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/delaware-business-tax-img.webp" />
                <source srcSet="/assets/images/delaware-business-tax-img.png" />
                <img
                  src="/assets/images/delaware-business-tax-img.png"
                  alt="Delaware Business Tax Requirements"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>

          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                {' '}
                <span className="highlight-container">
                  <span className="highlight">Delaware </span>
                </span>{' '}
                Business Tax Requirements
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                }}
              >
                Learn the business tax requirements in the Delaware state,
                including forms, deadlines, extensions, and franchise taxes, to
                stay compliant and avoid penalties.
              </Typography>
            </Box>
          </Box>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/delaware-business-tax-img-sm.webp" />
                <source srcSet="/assets/images/delaware-business-tax-img-sm.png" />
                <img
                  src="/assets/images/delaware-business-tax-img-sm.png"
                  alt="Delaware Business Tax Requirements "
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ pt: 4, pb: 4 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mb: 4,
              pt: 5,
              textAlign: 'center',
            }}
          >
            What are the Business Tax Forms in Delaware?
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, textAlign: 'center' }}>
            The tax forms you need to file in Delaware depend on your business
            structure.
          </Typography>
          <Typography variant="body1" sx={{ mb: 4, textAlign: 'center' }}>
            Here’s a breakdown:
          </Typography>

          <Grid container spacing={2} sx={{ mb: 5, justifyContent: 'center' }}>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 0, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/single-member-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/single-member-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/single-member-icon.png"
                    alt="Sole Proprietorship & Single-Member LLC"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Sole Proprietorship & <br /> Single-Member LLC
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://revenuefiles.delaware.gov/2024/PIT_2024_Forms/PIT-RES_2024-01_PaperInteractive.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form PIT-RES
                        </Link>{' '}
                        –
                      </span>{' '}
                      Delaware Resident Individual Income Tax Return
                    </li>

                    <li>
                      {' '}
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://revenuefiles.delaware.gov/2025/PITForms_Instructions/PIT-NON_2025-01_PaperInteractiveIPM.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Form PIT-NON
                        </Link>{' '}
                        -
                      </span>{' '}
                      Delaware Non-Resident Income Tax Return
                    </li>
                    <li>
                      {' '}
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.irs.gov/pub/irs-prior/f1040sc--2024.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Schedule C
                        </Link>{' '}
                        -
                      </span>{' '}
                      Profit or Loss from Business (filed with federal Form
                      1040)
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>{' '}
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 0, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/Partnership-income-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/Partnership-income-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/Partnership-income-icon.png"
                    alt="Partnership & Multi-Member LLC"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Partnership & Multi-Member LLC
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://revenuefiles.delaware.gov/2023/PRT-RTN_2023-01_PaperInteractive.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form PRT-RTN
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Partnership Return
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://revenuefiles.delaware.gov/2024/Business_Tax_Forms_2024_2025/PRT-PSI_2024-01_PaperInteractive.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form PRT-PSI
                        </Link>{' '}
                        –
                      </span>{' '}
                      Shareholder’s Share of Income, Deductions, Credits
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 0, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/c-corporation-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/c-corporation-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/c-corporation-icon.png"
                    alt="C Corporation"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    C Corporation
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        <Link
                          href="https://revenuefiles.delaware.gov/2023/CIT-TAX_2023-01_PaperInteractive.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form CIT-TAX
                        </Link>{' '}
                        –
                      </span>{' '}
                      Delaware Corporation Income Tax Return
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://revenuefiles.delaware.gov/2024/Business_Tax_Forms_2024_2025/CIT-EXM_2024-01_PaperInteractive.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form CIT-EXM
                        </Link>{' '}
                        -
                      </span>{' '}
                      Application for Exemption from Corporate Income Tax –
                      Holding Company
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://revenuefiles.delaware.gov/2024/Business_Tax_Forms_2024_2025/CIT-SCH_2024-01_PaperInteractive.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form CIT-SCH
                        </Link>{' '}
                        -
                      </span>{' '}
                      Corporate Schedule of Non-Business Income/Loss
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://revenuefiles.delaware.gov/2024/Business_Tax_Forms_2024_2025/CIT-HIC_2024-01_PaperInteractive.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form CIT-HIC
                        </Link>{' '}
                        -
                      </span>{' '}
                      Delaware Information Return Holding Company / Investment
                      Company
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://revenuefiles.delaware.gov/docs/1100CR.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 1100CR
                        </Link>{' '}
                        -
                      </span>{' '}
                      Computation Schedule for Tax Credits
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://revenuefiles.delaware.gov/docs/402AP.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 402AP
                        </Link>{' '}
                        -
                      </span>{' '}
                      Application for New Business Facility Tax Credit
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 0, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/s-corporation-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/s-corporation-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/s-corporation-icon.png"
                    alt="S Corporation"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    S Corporation
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://revenuefiles.delaware.gov/2024/Business_Tax_Forms_2024_2025/SCT-TAX_2025-01_PaperInteractive.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form SCT-TAX
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      S Corporation Personal Income Tax Return
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://revenuefiles.delaware.gov/2024/Business_Tax_Forms_2024_2025/SCT-SSA_2024-01_PaperInteractive.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form SCT-SSA
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      S Corporation Reconciliation and Shareholders Information
                      Schedule A Return
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://revenuefiles.delaware.gov/2023/SCT-RTN_2023-01_PaperInteractive.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form SCT-RTN
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      S Corporation Reconciliation and Shareholders Information
                      Return
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://revenuefiles.delaware.gov/2024/Business_Tax_Forms_2024_2025/SCT-SSR_2024-01_PaperInteractive.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form SCT-SSR
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      S Corporation Shareholders Information Return
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://revenuefiles.delaware.gov/2024/Business_Tax_Forms_2024_2025/SCT-REQ-2023-01_PaperInteractive.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form SCT-REQ
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      S-Corp Request for Change
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 0, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/business-tax-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/business-tax-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/business-tax-icon.png"
                    alt="Employer/ Payroll Withholding"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Employer/ Payroll Withholding
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://revenuefiles.delaware.gov/2021/WTH-TAX-2021-01_PaperInteractive.pdf"
                          sx={{ color: '#0202ff' }}
                          target="_blank"
                        >
                          {' '}
                          Form WTH-TAX
                        </Link>{' '}
                        –
                      </span>{' '}
                      Employer’s Withholding Tax Return
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://revenuefiles.delaware.gov/2021/TY21_W3_9801e.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form W-3
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Annual Reconciliation of Delaware Income Tax Withheld
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://revenuefiles.delaware.gov/2021/DE-W4.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form DE-W4
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Delaware W4 Withholding Allowance Cert & Computation
                      Worksheet – Resident / Non-Resident
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 0, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/property-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/property-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/property-icon.png"
                    alt="Additional Delaware Business Tax Forms"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Additional Delaware Business Tax Forms
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://revenuefiles.delaware.gov/2018/TY18_CRAe.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form CRA
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Combined Registration Application for Business License and
                      Tax Accounts
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://revenuefiles.delaware.gov/docs/req_license_tirefee.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form LREQ
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      License Request for Change
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://revenuefiles.delaware.gov/docs/402AP.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 402AP 9901
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Application for New Business Facility Tax Credits
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://revenuefiles.delaware.gov/docs/11_1100CR.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 1100CR 0101
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Computation Schedule for Delaware Economic Development
                      Credits
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://revenuefiles.delaware.gov/docs/1801AC.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 1801AC 0009
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Application & Computation Schedule for Land and Historic
                      Resource Conservation Tax Credits
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://revenuefiles.delaware.gov/2021/TY21_1811ACe.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 1811AC 0905
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Schedule for Delaware Historic Preservation Tax Credits
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Container
        component="section"
        maxWidth="lg"
        sx={{ pt: 6, pb: 6, textAlign: 'center' }}
      >
        <Grid
          container
          spacing={2}
          direction={{ md: 'row', xs: 'column' }}
          sx={{ pt: 2, pb: 2, justifyContent: 'center', mb: 2 }}
        >
          <Grid
            size={12}
            sx={{
              textAlign: { md: 'center', xs: 'center' },
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
            }}
          >
            <Box sx={{ px: { md: 0, sm: 0, xs: 2 } }}>
              {' '}
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: { md: 3, sm: 1, xs: 0 },
                  pt: { md: 0, sm: 3 },
                  textAlign: { md: 'center', sm: 'center' },
                }}
              >
                What are the Deadlines for the Business Tax Forms in Delaware?
              </Typography>
              <Typography
                variant="body1"
                sx={{ fontSize: { lg: 18, md: 16, sm: 14, xs: 14 }, mb: 3 }}
              >
                Here are key filing deadlines for business‑tax forms in
                Delaware, organized by entity type:
              </Typography>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Paper
              variant="outlined"
              sx={{
                p: 3,
                mb: 2,
                borderRadius: 4,
                minHeight: '100%',
                justifyContent: 'center',
                alignContent: 'center',
                background:
                  'linear-gradient(274deg,rgba(255, 247, 254, 1) 0%, rgba(189, 246, 255, 1) 100%)',
              }}
              // className="bg-pattern"
            >
              <Typography
                variant="h4"
                sx={{
                  fontSize: { lg: 24, md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                Partnerships <br />
                <span style={{ fontSize: 18, fontWeight: 500 }}>
                  (including LLCs taxed as partnerships)
                </span>
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 22, md: 20, sm: 18, xs: 16 },
                  fontWeight: 500,
                  textAlign: 'center',
                }}
              >
                Return due date:
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                }}
              >
                <Box
                  component="strong"
                  sx={{
                    fontWeight: 700,
                    fontSize: { lg: 48, md: 40, sm: 38, xs: 20 },
                    background:
                      'linear-gradient(63deg,rgba(69, 36, 124, 1) 0%, rgba(95, 58, 177, 1) 47%, rgba(145, 115, 200, 1) 100%)',
                    backgroundClip: 'text',
                    color: 'transparent',
                  }}
                >
                  15th day
                </Box>
                <br />
                of 3<sup>rd</sup> month
              </Typography>
            </Paper>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Paper
              variant="outlined"
              sx={{
                p: 3,
                mb: 2,
                borderRadius: 4,
                minHeight: '100%',
                justifyContent: 'center',
                alignContent: 'center',
                background:
                  'linear-gradient(274deg,rgba(255, 247, 254, 1) 0%, rgba(213, 189, 255, 1) 100%)',
              }}
              // className="bg-pattern"
            >
              <Stack
                spacing={2}
                direction={{ md: 'column', xs: 'column' }}
                justifyContent="center"
              >
                <Typography
                  variant="h4"
                  sx={{
                    fontSize: { lg: 24, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 2,
                    textAlign: 'center',
                  }}
                >
                  S Corporations
                </Typography>
                <Box
                  sx={{
                    textAlign: 'center',
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'center',
                    width: '100%',
                  }}
                >
                  <Box>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: { lg: 18, md: 16, sm: 14, xs: 14 },
                        fontWeight: 500,
                      }}
                    >
                      Return due date:{' '}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                      }}
                    >
                      <Box
                        component="strong"
                        sx={{
                          background:
                            'linear-gradient(63deg,rgba(69, 36, 124, 1) 0%, rgba(95, 58, 177, 1) 47%, rgba(145, 115, 200, 1) 100%)',
                          backgroundClip: 'text',
                          color: 'transparent',
                          fontWeight: 700,
                          fontSize: { lg: 48, md: 40, sm: 38, xs: 20 },
                        }}
                      >
                        15<sup>th</sup> day
                      </Box>{' '}
                      <br />
                      of 3<sup>rd</sup> month
                    </Typography>
                  </Box>
                </Box>
              </Stack>
            </Paper>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Paper
              variant="outlined"
              sx={{
                p: 3,
                mb: 2,
                borderRadius: 4,
                minHeight: '100%',
                justifyContent: 'center',
                alignContent: 'center',
                background:
                  'linear-gradient(274deg,rgba(255, 247, 254, 1) 0%, rgba(189, 246, 255, 1) 100%)',
              }}
              // className="bg-pattern"
            >
              <Typography
                variant="h4"
                sx={{
                  fontSize: { lg: 24, md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                C Corporations
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 22, md: 20, sm: 18, xs: 16 },
                  fontWeight: 500,
                  textAlign: 'center',
                }}
              >
                Return due date:
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                }}
              >
                <Box
                  component="strong"
                  sx={{
                    fontWeight: 700,
                    fontSize: { lg: 48, md: 40, sm: 38, xs: 20 },
                    background:
                      'linear-gradient(63deg,rgba(69, 36, 124, 1) 0%, rgba(95, 58, 177, 1) 47%, rgba(145, 115, 200, 1) 100%)',
                    backgroundClip: 'text',
                    color: 'transparent',
                  }}
                >
                  15<sup>th</sup> day
                </Box>
                <br />
                of 4<sup>th</sup> month
              </Typography>
            </Paper>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Paper
              variant="outlined"
              sx={{
                p: 3,
                mb: 2,
                borderRadius: 4,
                minHeight: '100%',
                justifyContent: 'center',
                alignContent: 'center',
                background:
                  'linear-gradient(274deg,rgba(255, 247, 254, 1) 0%, rgba(189, 246, 255, 1) 100%)',
              }}
              // className="bg-pattern"
            >
              <Typography
                variant="h3"
                sx={{
                  fontSize: { lg: 24, md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                Corporations <br />
                (Annual Franchise Tax + Report)
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 22, md: 20, sm: 18, xs: 16 },
                  fontWeight: 500,
                  textAlign: 'center',
                }}
              >
                Return due date:
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                }}
              >
                <Box
                  component="strong"
                  sx={{
                    fontWeight: 700,
                    fontSize: { lg: 48, md: 40, sm: 38, xs: 20 },
                    background:
                      'linear-gradient(63deg,rgba(69, 36, 124, 1) 0%, rgba(95, 58, 177, 1) 47%, rgba(145, 115, 200, 1) 100%)',
                    backgroundClip: 'text',
                    color: 'transparent',
                  }}
                >
                  March 1
                </Box>
              </Typography>
            </Paper>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Paper
              variant="outlined"
              sx={{
                p: 3,
                mb: 2,
                borderRadius: 4,
                minHeight: '100%',
                justifyContent: 'center',
                alignContent: 'center',
                background:
                  'linear-gradient(274deg,rgba(255, 247, 254, 1) 0%, rgba(189, 246, 255, 1) 100%)',
              }}
              // className="bg-pattern"
            >
              <Typography
                variant="h4"
                sx={{
                  fontSize: { lg: 24, md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                LLCs, LPs, GPs <br /> (Annual Tax)
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 22, md: 20, sm: 18, xs: 16 },
                  fontWeight: 500,
                  textAlign: 'center',
                }}
              >
                Return due date:
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                }}
              >
                <Box
                  component="strong"
                  sx={{
                    fontWeight: 700,
                    fontSize: { lg: 48, md: 40, sm: 38, xs: 20 },
                    background:
                      'linear-gradient(63deg,rgba(69, 36, 124, 1) 0%, rgba(95, 58, 177, 1) 47%, rgba(145, 115, 200, 1) 100%)',
                    backgroundClip: 'text',
                    color: 'transparent',
                  }}
                >
                  June 1
                </Box>
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Container>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            direction={{ md: 'row', xs: 'column-reverse' }}
            sx={{
              my: { xs: 2, sm: 6, md: 8 },
              textAlign: { md: 'left', sm: 'center', xs: 'center' },
            }}
            className="MuiGrid-root-width"
          >
            <Grid
              size={{ xs: 12, sm: 12, md: 6 }}
              sx={{
                textAlign: 'left',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                    textAlign: 'left',
                    lineHeight: 1.5,
                  }}
                >
                  What Business Extension Forms are required in Delaware?
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ mb: 0, fontSize: 20, fontWeight: 600 }}
                >
                  Business Type
                </Typography>
                <Box
                  component="ul"
                  sx={{
                    mb: 3,
                    mr: 2,
                    ml: -3,
                    listStyleType: 'none',
                    '& li': { mb: 1.5 },
                  }}
                >
                  <li>
                    <Box>
                      {' '}
                      <VerifiedIcon
                        sx={{ mb: -0.6, mr: 1, color: '#6436b7' }}
                      />
                      C Corporations{' '}
                      <Link
                        href="https://revenuefiles.delaware.gov/2024/Business_Tax_Forms_2024_2025/CIT-EXT_2024-01_PaperInteractive.pdf"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        Form CIT‑EXT
                      </Link>
                    </Box>
                  </li>
                  <li>
                    <Box>
                      {' '}
                      <VerifiedIcon
                        sx={{ mb: -0.6, mr: 1, color: '#6436b7' }}
                      />
                      LS Corporations{' '}
                      <Link
                        href="https://revenuefiles.delaware.gov/2024/Business_Tax_Forms_2024_2025/SCT-EXT_2024-01_PaperInteractive.pdf"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        Form SCT‑EXT
                      </Link>
                    </Box>{' '}
                  </li>
                  <li>
                    <Box>
                      {' '}
                      <VerifiedIcon
                        sx={{ mb: -0.6, mr: 1, color: '#6436b7' }}
                      />
                      Partnerships & LLCs (taxed as partnerships){' '}
                      <Link
                        href="https://revenuefiles.delaware.gov/2024/Business_Tax_Forms_2024_2025/PRT-EXT_2024-01_PaperInteractive.pdf"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        Form PRT‑EXT{' '}
                      </Link>
                    </Box>{' '}
                  </li>
                  <li>
                    <Box>
                      {' '}
                      <VerifiedIcon
                        sx={{ mb: -0.6, mr: 1, color: '#6436b7' }}
                      />
                      Annual Franchise Tax for Corporations{' '}
                      <Link
                        href="https://revenuefiles.delaware.gov/2022/TY22_1100T-T5_EXTe.pdf"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        Form 1100-T-EXT{' '}
                      </Link>
                    </Box>{' '}
                  </li>
                </Box>
                <Typography
                  variant="body1"
                  sx={{ mb: 0, fontSize: 20, fontWeight: 600 }}
                >
                  Payment Options:
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  Delaware business tax payments can also be made online via the
                  <Link
                    href="https://tax.delaware.gov/rptp/portal/home/!ut/p/z1/hY6xDoIwEIafhYFR7gLEELfGAcPiYFC8xZR4FpLaklIgvr1NXDHcdPf_35ccEDRARs69kr63Rupw32n_yAo8lidMq7K-pCjOos6vogpbDrctgEKNf0Zg8GkLqYCUtu3vG2HarFBAjl_s2CWTC3Hn_TAeYozR8cxm4uTJWi7ScaLsHOOa2NnRQ7PGw_BucEftZxFR9AWZ6PkS/dz/d5/L2dBISEvZ0FBIS9nQSEh/"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Delaware Division of Revenue e-Services portal.
                  </Link>{' '}
                  No prior registration is required for making payments.{' '}
                </Typography>
                <Alert
                  severity="warning"
                  icon={false}
                  sx={{ mb: 0, borderLeft: '3px solid rgb(102, 60, 0)' }}
                >
                  <b>Note: </b> TaxZerone supports{' '}
                  <Link
                    href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    filing Form 7004
                  </Link>{' '}
                  for federal business tax extensions and provides guidance for
                  Delaware state extension forms (CIT‑EXT, SCT‑EXT, PRT‑EXT,
                  1100-T-EXT, and 7004).
                </Alert>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              {/* <Link href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"> */}
              <Box
              // sx={{
              //   '&:hover': {
              //     transform: 'scale(1.02)',
              //   },
              //   '& .img-responsive:hover': {
              //     boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
              //   },
              //   transition: 'transform 0.3s ease-in-out',
              // }}
              >
                <picture>
                  <source srcSet="/assets/images/delaware-extension-img.webp" />
                  <source srcSet="/assets/images/delaware-extension-img.png" />
                  <img
                    src="/assets/images/delaware-extension-img.png"
                    alt="What Business Extension Forms are required in California?"
                    className="img-responsive"
                    loading="lazy"
                    width={500}
                    height={500}
                    style={{ borderRadius: 24 }}
                  />
                </picture>
              </Box>
              {/* </Link> */}
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ my: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} className="responsive" textAlign="center" mb={3}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                What are the Extended due dates for Business Tax
                <Hidden smDown>
                  {' '}
                  <br />
                </Hidden>
                forms in Delaware?
              </Typography>
              {/* <Typography variant="body1" sx={{ mb: 3, fontSize: 18 }}>
                Understand the key{' '}
                <span style={{ fontWeight: 600 }}> extended deadlines</span> for
                filing Connecticut business taxes for all entity types:
              </Typography> */}
              <Box sx={{ maxWidth: 1200, mx: 'auto' }}>
                <Stack
                  spacing={2}
                  direction={{ md: 'row', xs: 'column' }}
                  justifyContent="center"
                  sx={{ mb: 2 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 22, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      Partnerships (including LLCs taxed as partnerships)
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Extended due date:
                    </Typography>
                    <Typography variant="body1">
                      <Box
                        component="strong"
                        sx={{
                          fontSize: { lg: 36, md: 34, sm: 28, xs: 20 },
                          fontWeight: 700,
                          color: '#42247b',
                        }}
                      >
                        {' '}
                        15<sup>th</sup> Day
                      </Box>
                      <br />
                      of 9<sup>th</sup> month
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 3,
                        fontSize: { lg: 22, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      S Corporations
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Extended due date:
                    </Typography>
                    <Typography variant="body1">
                      <Box
                        component="strong"
                        sx={{
                          fontSize: { lg: 36, md: 34, sm: 28, xs: 20 },
                          fontWeight: 700,
                          color: '#42247b',
                        }}
                      >
                        {' '}
                        15<sup>th</sup> Day
                      </Box>
                      <br />
                      of 9<sup>th</sup> month
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 22, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      C Corporations
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Extended due date:
                    </Typography>
                    <Typography variant="body1">
                      <Box
                        component="strong"
                        sx={{
                          fontSize: { lg: 36, md: 34, sm: 28, xs: 20 },
                          fontWeight: 700,
                          color: '#42247b',
                        }}
                      >
                        {' '}
                        15<sup>th</sup> Day
                      </Box>
                      <br />
                      of 10<sup>th</sup> month
                    </Typography>
                  </Paper>
                </Stack>
                <Stack
                  spacing={2}
                  direction={{ md: 'row', xs: 'column' }}
                  justifyContent="center"
                  sx={{ mb: 2 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 22, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      Corporations <br /> (Annual Franchise Tax + Report)
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Extended due date:
                    </Typography>
                    <Typography variant="body1">
                      <Box
                        component="strong"
                        sx={{
                          fontSize: { lg: 36, md: 34, sm: 28, xs: 20 },
                          fontWeight: 700,
                          color: '#42247b',
                        }}
                      >
                        {' '}
                        September 1
                      </Box>
                    </Typography>
                  </Paper>{' '}
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 22, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      LLCs, LPs, GPs (Annual Tax)
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Extended due date:
                    </Typography>
                    <Typography variant="body1">
                      <Box
                        component="strong"
                        sx={{
                          fontSize: { lg: 36, md: 34, sm: 28, xs: 20 },
                          fontWeight: 700,
                          color: '#42247b',
                        }}
                      >
                        {' '}
                        December 1
                      </Box>
                    </Typography>
                  </Paper>
                </Stack>
              </Box>
              <Alert
                severity="warning"
                icon={false}
                sx={{
                  mb: 0,
                  mt: 4,
                  textAlign: 'left',
                  borderLeft: '3px solid rgb(102, 60, 0)',
                }}
              >
                <b>Note: </b> These extensions apply to filing the return, not
                the payment of taxes. Any tax due must still be paid by the
                original deadline to avoid interest or penalties.
              </Alert>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          mb: 5,
        }}
        spacing={2}
        m={0}
        // className="dotted-curve"
      >
        <Container
          maxWidth="xl"
          sx={{
            mb: 5,
            '& .card__content': {
              animation: 'scale linear forwards',
              animationTimeline: 'view()',
              animationRange: '85vh 100vh',
            },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: { xs: 'inherit', lg: 'sticky' },
              mt: 8,
              mb: 0,
              top: { md: 80, lg: 120, xl: 125 },
              // minHeight: { md: '50vh', lg: '60vh', xl: '70vh' },
              minHeight: { md: 550, lg: 615, xs: 695 },
              borderRadius: 6,
              px: 5,
              py: 3,
              background:
                'radial-gradient(circle,rgba(255, 255, 255, 1) 55%, rgba(237, 232, 232, 1) 86%, rgba(210, 186, 255, 1) 100%)',
              border: '1px solid #ccc',
            }}
            className="card__content"
          >
            <Stack
              spacing={2}
              direction={{ md: 'row', xs: 'column' }}
              justifyContent="center"
              alignItems="center"
            >
              <Box
                sx={{
                  textAlign: 'left',
                  alignItems: 'left',

                  justifyContent: 'left',
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                    textAlign: 'left',
                  }}
                >
                  Delaware Business Tax Extension Filing Requirements
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    mb: 3,
                    fontSize: { md: 20, sm: 18, xs: 16 },
                    fontWeight: 400,
                  }}
                >
                  To qualify for a business tax extension in Delaware, your
                  business must:
                </Typography>
                <Box sx={{ maxWidth: 'auto', textAlign: 'left' }}>
                  <Box
                    component="ul"
                    sx={{
                      mb: 0,
                      mr: 2,
                      listStyleType: 'none',
                      '& li': { mb: 2, fontSize: { md: 17, sm: 16, xs: 14 } },
                    }}
                  >
                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        File or pay by the original due date to avoid penalties.
                      </Box>
                    </li>
                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        Submit the correct extension form for your business
                        type: CIT‑EXT (C Corporations), SCT‑EXT (S
                        Corporations), PRT‑EXT (Partnerships/LLCs taxed as
                        partnerships), 7004 (Federal Form).
                      </Box>{' '}
                    </li>

                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        Estimate and pay any taxes owed; extensions apply to
                        filing only, not payments.
                      </Box>{' '}
                    </li>
                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        Follow the 6‑month filing extension:
                      </Box>{' '}
                    </li>
                    <ul>
                      <li>C Corps → October 15, </li>
                      <li>S Corps & Partnerships → September 15 </li>
                      <li>Franchise Tax → September 1 </li>
                      <li>Alternative‑Entity Tax → December 1 </li>
                    </ul>
                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        Keep records and confirmations from the Delaware
                        Division of Revenue.
                      </Box>{' '}
                    </li>
                  </Box>
                </Box>
              </Box>
              <Box>
                <Box sx={{ Height: 450 }}>
                  <picture>
                    <source
                      srcSet="/assets/images/delaware-state-img.webp"
                      className="mw-100"
                      width={550}
                      height={450}
                    />
                    <source
                      srcSet="/assets/images/delaware-state-img.png"
                      className="mw-100"
                      width={550}
                      height={450}
                    />
                    <img
                      src="/assets/images/delaware-state-img.png"
                      loading="lazy"
                      alt=" business tax extension in Delaware"
                      className="mw-100"
                      width={550}
                      height={450}
                    />
                  </picture>
                </Box>
              </Box>
            </Stack>
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: { xs: 'inherit', lg: 'sticky' },
              mt: 8,
              mb: 0,
              top: { md: 80, lg: 120, xl: 125 },
              // minHeight: { md: '50vh', lg: '60vh', xl: '70vh' },
              minHeight: { md: 550, lg: 615, xs: 695 },
              borderRadius: 6,
              px: 5,
              py: 3,
              background:
                'radial-gradient(circle,rgba(255, 255, 255, 1) 55%, rgba(237, 232, 232, 1) 86%, rgba(244, 237, 255, 1) 100%)',
              border: '1px solid #ccc',
            }}
            className="card__content"
          >
            <Grid
              container
              spacing={2}
              justifyContent="center"
              sx={{ maxWidth: 'container' }}
            >
              <Grid size={{ xs: 12, sm: 6, md: 12 }}>
                <Box
                  component="div"
                  sx={{
                    mb: 3,
                    textAlign: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                      fontWeight: 600,
                      mb: 1,
                    }}
                  >
                    Delaware Business Tax Rates
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      mb: 1,
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      fontWeight: 400,
                      textAlign: 'center',
                    }}
                  >
                    Business tax rates vary depending on your entity type:
                  </Typography>
                </Box>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    minHeight: '100%',
                    textAlign: 'center',
                    alignContent: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f0f2f9',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 21, sm: 18, xs: 16 },
                    }}
                  >
                    C Corporation
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 600, fontSize: 36, color: '#291972' }}
                  >
                    8.7%
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: 18 }}>
                    of federal taxable income allocated to Delaware
                  </Typography>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    minHeight: '100%',
                    textAlign: 'center',
                    alignContent: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f0f2f9',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 21, sm: 18, xs: 16 },
                    }}
                  >
                    LLCs, LPs, GPs
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 36, sm: 28, xs: 20 },
                      color: '#291972',
                    }}
                  >
                    $300
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: 18 }}>
                    flat annual tax per entity
                  </Typography>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    minHeight: '100%',
                    textAlign: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f0f2f9',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 21, sm: 18, xs: 16 },
                    }}
                  >
                    Exempt Organizations
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 36, sm: 28, xs: 20 },
                      color: '#291972',
                    }}
                  >
                    Exempt
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: 18 }}>
                    Generally, exempt from state tax, but may pay on unrelated
                    business income
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Grid>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container
          maxWidth="lg"
          sx={{
            my: { xs: 0, md: 3, lg: 5 },
            py: { xs: 2, sm: 5, md: 3, lg: 3 },
            //   borderRadius: { xs: 0, md: 4 },
            //   mx: { xs: 0, md: 3, lg: 'auto' },
          }}
          // className="gradient-bg"
        >
          <Grid
            container
            spacing={2}
            direction={{ sm: 'row', xs: 'column-reverse' }}
          >
            <Grid
              size={12}
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
              }}
              className="responsive"
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                    textAlign: 'center',
                  }}
                >
                  Estimated tax payments for Delaware Businesses
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    mb: 3,
                    fontSize: { md: 19, sm: 18, xs: 16 },
                    fontWeight: 400,
                  }}
                >
                  Businesses in Delaware must make estimated tax payments if
                  they expect to owe{' '}
                  <span style={{ fontWeight: 600 }}>more than $5,000 </span>
                  <Hidden smDown>
                    {' '}
                    <br />
                  </Hidden>
                  in state income tax for the year. These prepayments help avoid
                  underpayment penalties and interest.
                </Typography>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  borderRadius: 2,
                  backgroundColor: '#f0f2f9',
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    mb: 3,
                    fontSize: { md: 21, sm: 18, xs: 16 },
                    textAlign: 'center',
                  }}
                >
                  Payment Deadlines
                </Typography>
                <Stack
                  spacing={2}
                  direction={{ xs: 'column', sm: 'row' }}
                  sx={{ mb: 2 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 500, fontSize: 18, mb: 1 }}
                    >
                      1<sup>st</sup> payment
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: 25,
                        fontWeight: 700,
                        mb: 2,
                        color: '#42247b',
                      }}
                    >
                      April 1
                    </Typography>
                    <Typography variant="body1">
                      (50% of estimated tax)
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 500, fontSize: 18, mb: 1 }}
                    >
                      2<sup>nd</sup> payment
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: 25,
                        fontWeight: 700,
                        mb: 2,
                        color: '#42247b',
                      }}
                    >
                      June 15
                    </Typography>
                    <Typography variant="body1">
                      (20% of estimated tax)
                    </Typography>
                  </Paper>
                </Stack>
                <Stack
                  spacing={2}
                  direction={{ xs: 'column', sm: 'row' }}
                  sx={{ mb: 0 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 500, fontSize: 18, mb: 1 }}
                    >
                      3<sup>rd</sup> Payment
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: 25,
                        fontWeight: 700,
                        mb: 2,
                        color: '#42247b',
                      }}
                    >
                      Sept 15
                    </Typography>
                    <Typography variant="body1">
                      (20% of estimated tax)
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 500, fontSize: 18, mb: 1 }}
                    >
                      4<sup>th</sup> Payment
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: 25,
                        fontWeight: 700,
                        mb: 2,
                        color: '#42247b',
                      }}
                    >
                      Dec 15
                    </Typography>
                    <Typography variant="body1">
                      (10% of estimated tax)
                    </Typography>
                  </Paper>
                </Stack>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  borderRadius: 2,
                  backgroundColor: '#f0f2f9',
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    mb: 3,
                    fontSize: { md: 21, sm: 18, xs: 16 },
                    textAlign: 'center',
                  }}
                >
                  Who should pay
                </Typography>
                <Stack
                  spacing={2}
                  direction={{ xs: 'column', sm: 'row' }}
                  sx={{ mb: 2 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, fontSize: 18, mb: 1 }}
                    >
                      C Corporations
                    </Typography>
                    <Typography variant="body1">
                      Required to make estimated tax payments if they expect to
                      owe any corporate income tax for the year.
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, fontSize: 18, mb: 1 }}
                    >
                      S Corporations
                    </Typography>
                    <Typography variant="body1">
                      Generally, not required to pay estimated tax at the entity
                      level; shareholders pay individually on pass-through
                      income.
                    </Typography>
                  </Paper>
                </Stack>
                <Stack
                  spacing={2}
                  direction={{ xs: 'column', sm: 'row' }}
                  sx={{ mb: 0 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, fontSize: 18, mb: 1 }}
                    >
                      Partnerships & LLCs taxed as partnerships
                    </Typography>
                    <Typography variant="body1">
                      No entity-level estimated payments; partners or members
                      pay individually on their share of income.
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, fontSize: 18, mb: 1 }}
                    >
                      LLCs, LPs & GPs (Alternative-Entity Tax)
                    </Typography>
                    <Typography variant="body1">
                      Flat annual tax of{' '}
                      <span style={{ fontWeight: 600 }}> $300, due June 1</span>{' '}
                      — no quarterly estimated payments required.
                    </Typography>
                  </Paper>
                </Stack>
              </Paper>
            </Grid>
            <Grid
              size={12}
              sx={{
                mt: 2,
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
              }}
              className="responsive"
            >
              <Box
                component="div"
                sx={{
                  backgroundColor: '#f5efff',
                  borderLeft: '5px solid #45247e',
                  p: 2,
                  mb: 4,
                  borderRadius: 2,
                  textAlign: 'left',
                }}
              >
                <Typography variant="body1" sx={{ fontSize: 14, mt: 0 }}>
                  <span style={{ fontWeight: 600 }}> Missed Payments:</span>{' '}
                  Late or missed estimated payments may result in{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    interest and penalties
                  </span>{' '}
                  from the Delaware Division of Revenue.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          pt: 8,
        }}
        spacing={2}
        m={0}
        // className="dotted-curve"
      >
        <Container maxWidth="lg" sx={{ pt: 2, mb: 5 }}>
          <Grid container spacing={2} justifyContent="center">
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mt: 0,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                Penalties and Interest for Business in Delaware
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mb: 3,
                  fontSize: { md: 18, sm: 16, xs: 16 },
                  textAlign: 'center',
                }}
              >
                If your business doesn’t pay the required tax by the original
                due date,
                <Hidden smDown>
                  {' '}
                  <br />{' '}
                </Hidden>{' '}
                {'  '}
                <span style={{ fontWeight: 600 }}>
                  {' '}
                  penalties and interest
                </span>{' '}
                may apply—even if you’ve filed an extension.
              </Typography>
              <Stack
                spacing={2}
                direction={{ xs: 'column', sm: 'row' }}
                justifyContent="center"
                sx={{ mb: 0 }}
              >
                <Box
                  sx={{
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      mb: 2,
                      minHeight: '100%',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { md: 21, sm: 18, xs: 16 },
                      }}
                    >
                      Late Payment Penalty
                    </Typography>
                    <Typography variant="body1">
                      An additional{' '}
                      <span style={{ fontWeight: 600 }}>0.5% per month,</span>{' '}
                      not to exceed{' '}
                      <span style={{ fontWeight: 600 }}>25%,</span> is charged
                      for failure to pay the full tax liability shown on a
                      timely filed return.
                    </Typography>
                  </Paper>
                </Box>
                <Box
                  sx={{
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      mb: 2,
                      minHeight: '100%',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { md: 21, sm: 18, xs: 16 },
                      }}
                    >
                      Late Filing Penalty
                    </Typography>
                    <Typography variant="body1">
                      Returns filed after the due date are subject to a{' '}
                      <span style={{ fontWeight: 600 }}>
                        5% penalty per month,
                      </span>{' '}
                      up to a{' '}
                      <span style={{ fontWeight: 600 }}>maximum of 50%</span> of
                      the total tax due.
                    </Typography>
                  </Paper>
                </Box>
                <Box
                  sx={{
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      mb: 2,
                      minHeight: '100%',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { md: 21, sm: 18, xs: 16 },
                      }}
                    >
                      Interest
                    </Typography>
                    <Typography variant="body1">
                      Interest accrues at{' '}
                      <span style={{ fontWeight: 600 }}>1% per month</span> from
                      the original due date until the tax is fully paid.
                    </Typography>
                  </Paper>
                </Box>
                <Box
                  sx={{
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      mb: 2,
                      minHeight: '100%',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { md: 21, sm: 18, xs: 16 },
                      }}
                    >
                      Estimated Tax Underpayment
                    </Typography>
                    <Typography variant="body1">
                      A penalty of{' '}
                      <span style={{ fontWeight: 600 }}>1.5% per month</span>{' '}
                      applies if estimated tax installments are not paid, paid
                      late, or underpaid.
                    </Typography>
                  </Paper>
                </Box>
              </Stack>

              <Alert
                severity="warning"
                icon={false}
                sx={{ mb: 3, mt: 3, borderLeft: '3px solid rgb(102, 60, 0)' }}
              >
                <b>Note: </b> These penalties apply to most business entities in
                Delaware, including corporations, LLCs, and partnerships.
              </Alert>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mt: 4, mb: 7 }}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 12, md: 6 }} sx={{ mt: 4 }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                }}
                className="image-container"
              >
                <picture>
                  <source srcSet="/assets/images/state-help-img.webp" />
                  <source srcSet="/assets/images/state-help-img.png" />
                  <img
                    src="/assets/images/state-help-img.png"
                    alt="How TaxZerone can Help You?"
                    className="img-responsive"
                    loading="lazy"
                    width={450}
                    height={450}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 12, md: 6 }}
              sx={{
                textAlign: { md: 'left', sm: 'left' },
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                m: 0,
              }}
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mt: 3,

                    textAlign: 'left',
                  }}
                >
                  How TaxZerone can Help You?
                </Typography>

                <Typography variant="body1" sx={{ mt: 2, mb: 0 }}>
                  TaxZerone simplifies your Delaware business tax compliance by
                  supporting{' '}
                  <span style={{ fontWeight: 600 }}> federal tax filings</span>{' '}
                  and{' '}
                  <span style={{ fontWeight: 600 }}>
                    guiding you through state filing requirements
                  </span>
                  . Whether you need to file federal business returns, request
                  extensions using{' '}
                  <Link
                    href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Form 7004
                  </Link>
                  , or understand Delaware-specific forms and deadlines,
                  TaxZerone ensures a smooth and accurate filing experience
                  every step of the way.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        component="section"
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Stay compliant and avoid last-minute stress!
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 2,
            lineHeight: 1.5,
          }}
        >
          File your federal returns, request business tax extensions, and get
          <Hidden smDown>
            {' '}
            <br />
          </Hidden>
          step-by-step guidance for Delaware state filings — all in one place.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=delaware`}
          >
            E-file Now
          </Button>
        </Box>
      </Box>
      <Container component="section" maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 5 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
            className="responsive"
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. What forms does my business need to file in California
                  State?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text" sx={{ mt: 1 }}>
                    <Typography variant="body1" sx={{ mb: 0 }}>
                      The forms your business must file in Delaware depend on
                      its entity type. Sole proprietors and single-member LLCs
                      file{' '}
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Form PIT-RES, PIT-NON, Schedule C,
                      </span>{' '}
                      and a{' '}
                      <span style={{ fontWeight: 600 }}>
                        Gross Receipts Tax Return.
                      </span>{' '}
                      Partnerships and multi-member LLCs file{' '}
                      <span style={{ fontWeight: 600 }}>Form PRT-RTN</span> and
                      <span style={{ fontWeight: 600 }}> PRT-PSI</span>. C
                      corporations file{' '}
                      <span style={{ fontWeight: 600 }}>Form CIT-TAX</span> and
                      related schedules, while S corporations file{' '}
                      <span style={{ fontWeight: 600 }}>Form SCT-TAX</span> with
                      shareholder schedules. Employers must file{' '}
                      <span style={{ fontWeight: 600 }}>Form WTH-TAX</span>
                      and <span style={{ fontWeight: 600 }}>Form W-3</span>. All
                      businesses also need a Delaware Business License and may
                      owe Gross Receipts Tax.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. Do LLCs and Partnerships pay income tax in Delaware?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1, mb: 1 }}>
                      LLCs and partnerships are{' '}
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        not subject to corporate income tax
                      </span>{' '}
                      at the entity level. Instead, profits “pass through” to
                      members or partners who report income on their personal
                      returns. However, these entities must pay a{' '}
                      <span style={{ fontWeight: 600 }}>
                        flat annual tax of $300,
                      </span>{' '}
                      due by <span style={{ fontWeight: 600 }}>June 1</span>{' '}
                      each year.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. How do I register my business for Delaware taxes?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1, mb: 0 }}>
                      You can register using{' '}
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Form CRA (Combined Registration Application)
                      </span>{' '}
                      through the Delaware Division of Revenue. This form sets
                      up your{' '}
                      <span style={{ fontWeight: 600 }}>
                        business license, withholding, and gross receipts of
                        accounts
                      </span>{' '}
                      in one process.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. Does Delaware accept consolidated returns?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography sx={{ mt: 1 }}>
                      No. Delaware does not allow consolidated corporate income
                      tax returns. Each corporation in a consolidated group must
                      file its{' '}
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        own separate return,
                      </span>{' '}
                      reporting income and deductions as if it filed
                      independently for federal tax purposes.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  5. Does Delaware accept corporate income tax returns filed via
                  magnetic media?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography sx={{ mt: 1 }}>
                      No. Delaware does not accept corporate, S-corporation,
                      partnership, or fiduciary tax returns submitted through
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        magnetic media
                      </span>{' '}
                      (such as hard drives or floppy disks). All corporate
                      income tax returns and attachments must be{' '}
                      <span style={{ fontWeight: 600 }}>
                        filed in paper form
                      </span>
                      .
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>{' '}
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default BusinessStateDelaware;
